export var CountriesEnum;
(function (CountriesEnum) {
    CountriesEnum["AF"] = "AF";
    CountriesEnum["AX"] = "AX";
    CountriesEnum["AL"] = "AL";
    CountriesEnum["DZ"] = "DZ";
    CountriesEnum["AS"] = "AS";
    CountriesEnum["AD"] = "AD";
    CountriesEnum["AO"] = "AO";
    CountriesEnum["AI"] = "AI";
    CountriesEnum["AQ"] = "AQ";
    CountriesEnum["AG"] = "AG";
    CountriesEnum["AR"] = "AR";
    CountriesEnum["AM"] = "AM";
    CountriesEnum["AW"] = "AW";
    CountriesEnum["AU"] = "AU";
    CountriesEnum["AT"] = "AT";
    CountriesEnum["AZ"] = "AZ";
    CountriesEnum["BS"] = "BS";
    CountriesEnum["BH"] = "BH";
    CountriesEnum["BD"] = "BD";
    CountriesEnum["BB"] = "BB";
    CountriesEnum["BY"] = "BY";
    CountriesEnum["BE"] = "BE";
    CountriesEnum["BZ"] = "BZ";
    CountriesEnum["BJ"] = "BJ";
    CountriesEnum["BM"] = "BM";
    CountriesEnum["BT"] = "BT";
    CountriesEnum["BO"] = "BO";
    CountriesEnum["BA"] = "BA";
    CountriesEnum["BW"] = "BW";
    CountriesEnum["BV"] = "BV";
    CountriesEnum["BR"] = "BR";
    CountriesEnum["IO"] = "IO";
    CountriesEnum["BN"] = "BN";
    CountriesEnum["BG"] = "BG";
    CountriesEnum["BF"] = "BF";
    CountriesEnum["BI"] = "BI";
    CountriesEnum["KH"] = "KH";
    CountriesEnum["CM"] = "CM";
    CountriesEnum["CA"] = "CA";
    CountriesEnum["CV"] = "CV";
    CountriesEnum["KY"] = "KY";
    CountriesEnum["CF"] = "CF";
    CountriesEnum["TD"] = "TD";
    CountriesEnum["CL"] = "CL";
    CountriesEnum["CN"] = "CN";
    CountriesEnum["CX"] = "CX";
    CountriesEnum["CC"] = "CC";
    CountriesEnum["CO"] = "CO";
    CountriesEnum["KM"] = "KM";
    CountriesEnum["CG"] = "CG";
    CountriesEnum["CD"] = "CD";
    CountriesEnum["CK"] = "CK";
    CountriesEnum["CR"] = "CR";
    CountriesEnum["CI"] = "CI";
    CountriesEnum["HR"] = "HR";
    CountriesEnum["CU"] = "CU";
    CountriesEnum["CW"] = "CW";
    CountriesEnum["CY"] = "CY";
    CountriesEnum["CZ"] = "CZ";
    CountriesEnum["DK"] = "DK";
    CountriesEnum["DJ"] = "DJ";
    CountriesEnum["DM"] = "DM";
    CountriesEnum["DO"] = "DO";
    CountriesEnum["EC"] = "EC";
    CountriesEnum["EG"] = "EG";
    CountriesEnum["SV"] = "SV";
    CountriesEnum["GQ"] = "GQ";
    CountriesEnum["ER"] = "ER";
    CountriesEnum["EE"] = "EE";
    CountriesEnum["ET"] = "ET";
    CountriesEnum["FK"] = "FK";
    CountriesEnum["FO"] = "FO";
    CountriesEnum["FJ"] = "FJ";
    CountriesEnum["FI"] = "FI";
    CountriesEnum["FR"] = "FR";
    CountriesEnum["GF"] = "GF";
    CountriesEnum["PF"] = "PF";
    CountriesEnum["TF"] = "TF";
    CountriesEnum["GA"] = "GA";
    CountriesEnum["GM"] = "GM";
    CountriesEnum["GE"] = "GE";
    CountriesEnum["DE"] = "DE";
    CountriesEnum["GH"] = "GH";
    CountriesEnum["GI"] = "GI";
    CountriesEnum["GR"] = "GR";
    CountriesEnum["GL"] = "GL";
    CountriesEnum["GD"] = "GD";
    CountriesEnum["GP"] = "GP";
    CountriesEnum["GU"] = "GU";
    CountriesEnum["GT"] = "GT";
    CountriesEnum["GG"] = "GG";
    CountriesEnum["GN"] = "GN";
    CountriesEnum["GW"] = "GW";
    CountriesEnum["GY"] = "GY";
    CountriesEnum["HT"] = "HT";
    CountriesEnum["HM"] = "HM";
    CountriesEnum["VA"] = "VA";
    CountriesEnum["HN"] = "HN";
    CountriesEnum["HK"] = "HK";
    CountriesEnum["HU"] = "HU";
    CountriesEnum["IS"] = "IS";
    CountriesEnum["IN"] = "IN";
    CountriesEnum["ID"] = "ID";
    CountriesEnum["IR"] = "IR";
    CountriesEnum["IQ"] = "IQ";
    CountriesEnum["IE"] = "IE";
    CountriesEnum["IM"] = "IM";
    CountriesEnum["IL"] = "IL";
    CountriesEnum["IT"] = "IT";
    CountriesEnum["JM"] = "JM";
    CountriesEnum["JP"] = "JP";
    CountriesEnum["JE"] = "JE";
    CountriesEnum["JO"] = "JO";
    CountriesEnum["KZ"] = "KZ";
    CountriesEnum["KE"] = "KE";
    CountriesEnum["KI"] = "KI";
    CountriesEnum["KR"] = "KR";
    CountriesEnum["KP"] = "KP";
    CountriesEnum["KW"] = "KW";
    CountriesEnum["KG"] = "KG";
    CountriesEnum["LA"] = "LA";
    CountriesEnum["LV"] = "LV";
    CountriesEnum["LB"] = "LB";
    CountriesEnum["LS"] = "LS";
    CountriesEnum["LR"] = "LR";
    CountriesEnum["LY"] = "LY";
    CountriesEnum["LI"] = "LI";
    CountriesEnum["LT"] = "LT";
    CountriesEnum["LU"] = "LU";
    CountriesEnum["MO"] = "MO";
    CountriesEnum["MG"] = "MG";
    CountriesEnum["MW"] = "MW";
    CountriesEnum["MY"] = "MY";
    CountriesEnum["MV"] = "MV";
    CountriesEnum["ML"] = "ML";
    CountriesEnum["MT"] = "MT";
    CountriesEnum["MH"] = "MH";
    CountriesEnum["MQ"] = "MQ";
    CountriesEnum["MR"] = "MR";
    CountriesEnum["MU"] = "MU";
    CountriesEnum["YT"] = "YT";
    CountriesEnum["MX"] = "MX";
    CountriesEnum["FM"] = "FM";
    CountriesEnum["MD"] = "MD";
    CountriesEnum["MC"] = "MC";
    CountriesEnum["MN"] = "MN";
    CountriesEnum["ME"] = "ME";
    CountriesEnum["MS"] = "MS";
    CountriesEnum["MA"] = "MA";
    CountriesEnum["MZ"] = "MZ";
    CountriesEnum["MM"] = "MM";
    CountriesEnum["NA"] = "NA";
    CountriesEnum["NR"] = "NR";
    CountriesEnum["NP"] = "NP";
    CountriesEnum["NL"] = "NL";
    CountriesEnum["NC"] = "NC";
    CountriesEnum["NZ"] = "NZ";
    CountriesEnum["NI"] = "NI";
    CountriesEnum["NE"] = "NE";
    CountriesEnum["NG"] = "NG";
    CountriesEnum["NU"] = "NU";
    CountriesEnum["NF"] = "NF";
    CountriesEnum["MP"] = "MP";
    CountriesEnum["NO"] = "NO";
    CountriesEnum["OM"] = "OM";
    CountriesEnum["PK"] = "PK";
    CountriesEnum["PW"] = "PW";
    CountriesEnum["PS"] = "PS";
    CountriesEnum["PA"] = "PA";
    CountriesEnum["PG"] = "PG";
    CountriesEnum["PY"] = "PY";
    CountriesEnum["PE"] = "PE";
    CountriesEnum["PH"] = "PH";
    CountriesEnum["PN"] = "PN";
    CountriesEnum["PL"] = "PL";
    CountriesEnum["PT"] = "PT";
    CountriesEnum["PR"] = "PR";
    CountriesEnum["QA"] = "QA";
    CountriesEnum["RE"] = "RE";
    CountriesEnum["MKD"] = "MKD";
    CountriesEnum["RO"] = "RO";
    CountriesEnum["RU"] = "RU";
    CountriesEnum["RW"] = "RW";
    CountriesEnum["BL"] = "BL";
    CountriesEnum["SH"] = "SH";
    CountriesEnum["KN"] = "KN";
    CountriesEnum["LC"] = "LC";
    CountriesEnum["MF"] = "MF";
    CountriesEnum["PM"] = "PM";
    CountriesEnum["VC"] = "VC";
    CountriesEnum["WS"] = "WS";
    CountriesEnum["SM"] = "SM";
    CountriesEnum["ST"] = "ST";
    CountriesEnum["SA"] = "SA";
    CountriesEnum["SN"] = "SN";
    CountriesEnum["RS"] = "RS";
    CountriesEnum["SC"] = "SC";
    CountriesEnum["SL"] = "SL";
    CountriesEnum["SG"] = "SG";
    CountriesEnum["SK"] = "SK";
    CountriesEnum["SI"] = "SI";
    CountriesEnum["SB"] = "SB";
    CountriesEnum["SO"] = "SO";
    CountriesEnum["ZA"] = "ZA";
    CountriesEnum["GS"] = "GS";
    CountriesEnum["ES"] = "ES";
    CountriesEnum["LK"] = "LK";
    CountriesEnum["SD"] = "SD";
    CountriesEnum["SS"] = "SS";
    CountriesEnum["SR"] = "SR";
    CountriesEnum["SJ"] = "SJ";
    CountriesEnum["SZ"] = "SZ";
    CountriesEnum["SE"] = "SE";
    CountriesEnum["CH"] = "CH";
    CountriesEnum["SX"] = "SX";
    CountriesEnum["SY"] = "SY";
    CountriesEnum["TW"] = "TW";
    CountriesEnum["TJ"] = "TJ";
    CountriesEnum["TZ"] = "TZ";
    CountriesEnum["TH"] = "TH";
    CountriesEnum["TL"] = "TL";
    CountriesEnum["TG"] = "TG";
    CountriesEnum["TK"] = "TK";
    CountriesEnum["TO"] = "TO";
    CountriesEnum["TT"] = "TT";
    CountriesEnum["TN"] = "TN";
    CountriesEnum["TR"] = "TR";
    CountriesEnum["TM"] = "TM";
    CountriesEnum["TC"] = "TC";
    CountriesEnum["TV"] = "TV";
    CountriesEnum["UG"] = "UG";
    CountriesEnum["UA"] = "UA";
    CountriesEnum["AE"] = "AE";
    CountriesEnum["GB"] = "GB";
    CountriesEnum["US"] = "US";
    CountriesEnum["UM"] = "UM";
    CountriesEnum["UY"] = "UY";
    CountriesEnum["UZ"] = "UZ";
    CountriesEnum["VU"] = "VU";
    CountriesEnum["VE"] = "VE";
    CountriesEnum["VN"] = "VN";
    CountriesEnum["VG"] = "VG";
    CountriesEnum["VI"] = "VI";
    CountriesEnum["WF"] = "WF";
    CountriesEnum["EH"] = "EH";
    CountriesEnum["YE"] = "YE";
    CountriesEnum["ZM"] = "ZM";
    CountriesEnum["ZW"] = "ZW";
})(CountriesEnum || (CountriesEnum = {}));
//# sourceMappingURL=countries.enum.js.map